<script>
import { mapGetters } from "vuex";

import API from "@/api";

import Loader from "@/components/_base/Loader";

import Welcome from "./components/Welcome";
import Empty from "./components/Payables/Empty";
import InfoCards from "./components/InfoCards/Index";
import ProvisioningPayables from "./components/Payables/ProvisioningPayables";
import PendingPayables from "./components/Payables/PendingPayables";
import ConfirmedPayables from "./components/Payables/ConfirmedPayables";

import EmailNotVerifiedNotice from "@/components/_Shared/Warnings/EmailNotVerified/Notice";
import BannerFirstOrder from "@/components/Banners/BannerFirstOrder";
import Banner from "@/components/Banners/BannerSuperPromo";
// import BannerImg from "@/components/Banners/BannerImg";

export default {
  components: {
    Loader,
    Welcome,
    Empty,
    InfoCards,
    ProvisioningPayables,
    PendingPayables,
    ConfirmedPayables,
    EmailNotVerifiedNotice,
    BannerFirstOrder,
    Banner
    // BannerImg
  },

  data() {
    return {
      preloader: true,
      loadingMessage: "Buscando Pedidos...",
      ordersNotProvided: [],
      ordersProvisioning: [],
      pendingOrders: [],
      pendingCycles: [],
      confirmedOrders: [],
      bottomOfScreen: false
    };
  },

  methods: {
    async retrieveDashboardOrders() {
      this.preloader = true;

      await this.getOrdersNotProvided();
      await new Promise(resolve => setTimeout(resolve, 500));

      await this.getProvisioningOrders();
      await new Promise(resolve => setTimeout(resolve, 500));

      await this.getPendingOrders();
      await this.getPendingCycles();
      await new Promise(resolve => setTimeout(resolve, 500));

      await this.getConfirmedOrders();

      this.preloader = false;
    },

    async getOrdersNotProvided() {
      try {
        this.loadingMessage = "Buscando limpezas não realizadas...";

        this.ordersNotProvided = await API.Orders.ordersNotProvided();
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao buscar os pedidos não realizados."
        );
      }
    },

    async getProvisioningOrders() {
      try {
        this.loadingMessage = "Buscando limpezas acontecendo agora...";

        this.ordersProvisioning = await API.Orders.ordersProvisioned();
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao buscar as limpezas acontecendo agora."
        );
      }
    },

    async getPendingOrders() {
      try {
        this.loadingMessage = "Buscando limpezas pendentes de pagamento...";

        this.pendingOrders = await API.Orders.ordersPendingPayment();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao buscar os pedidos pendentes.");
      }
    },

    async getPendingCycles() {
      try {
        this.pendingCycles = await API.Cycles.cyclePendingPayment();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao buscar os ciclos pendentes.");
      }
    },

    async getConfirmedOrders() {
      this.loadingMessage = "Buscando limpezas futuras...";

      try {
        this.confirmedOrders = await API.Orders.ordersConfirmed();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao buscar os pedidos futuros.");
      }
    },

    handleScroll() {
      const windowHeight =
        this.$refs.container.clientHeight +
        150 +
        (this.ordersNotProvided.length ? 210 : 120);
      const windowPosition = window.pageYOffset + window.innerHeight + 100;

      if (windowHeight <= windowPosition) {
        return (this.bottomOfScreen = true);
      }

      this.bottomOfScreen = false;
    }
  },

  computed: {
    ...mapGetters("user", ["firstOrderUser"]),

    noFutureOrders: function() {
      return !(
        this.pendingOrders.length ||
        this.pendingCycles.length ||
        this.confirmedOrders.length ||
        this.ordersProvisioning.length
      );
    }
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },

  async mounted() {
    await this.retrieveDashboardOrders();
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<template>
  <div class="container" ref="container">
    <div class="dashboard" :class="{'double-margin': bottomOfScreen && !ordersNotProvided.length, 'extra-margin': ordersNotProvided.length, 'double-extra-margin': bottomOfScreen && ordersNotProvided.length }">
      <div class="left">
        <div class="mobile">
          <BannerFirstOrder v-if="firstOrderUser" />
          <!-- <BannerImg v-else /> -->

          <EmailNotVerifiedNotice />
        </div>

        <Welcome :ordersNotProvided="ordersNotProvided" :isAtBottomOfWindow="bottomOfScreen" />

        <transition name="down" mode="out-in">
          <div class="loader" v-if="preloader">
            <Loader indeterminate />

            <p>{{ loadingMessage }}</p>
          </div>
        </transition>

        <Empty v-if="!preloader && noFutureOrders" />

        <ProvisioningPayables
          :ordersProvisioning="ordersProvisioning"
        />

        <PendingPayables
          :pendingOrders="pendingOrders"
          :pendingCycles="pendingCycles"
        />

        <ConfirmedPayables :confirmedOrders="confirmedOrders" />
      </div>

      <div class='right'>
        <div class="desktop">
          <BannerFirstOrder v-if="firstOrderUser" />
          <!-- <BannerImg v-else /> -->

          <EmailNotVerifiedNotice />
        </div>

        <InfoCards />
      </div>
    </div>
  </div>
</template>

<style scoped>
.dashboard {
  width: 100%;
  margin-bottom: 120px;
  display: flex;
  flex-direction: column;
}

.double-margin {
  margin-bottom: 156px;
}

.extra-margin {
  margin-bottom: 210px;
}

.double-extra-margin {
  margin-bottom: 246px;
}

.left {
  width: 100%;
  margin-bottom: 32px;
}

.left > *:nth-child(n + 3) {
  margin-top: 24px;
}

.loader {
  padding: 24px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  border-radius: 2px;
}

.loader > p {
  margin-bottom: 0;
}

.right {
  width: 100%;
}

.mobile {
  display: inherit;
}

.mobile > *:not(:first-child) {
  margin-top: 24px;
}

.desktop {
  display: none;
}

@media (min-width: 768px) {
  .dashboard {
    margin-bottom: 0;
    flex-direction: row;
    justify-content: space-between;
  }

  .left {
    width: 45%;
    margin-bottom: 0;
  }

  .right {
    width: 52%;
  }

  .mobile {
    display: none;
  }

  .desktop {
    display: inherit;
  }

  .desktop > * {
    margin-bottom: 24px;
  }
}

@media (min-width: 1024px) {
  .left {
    width: 45%;
  }

  .right {
    width: 52%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Index.vue